import builder from '../builder';
import RealEstateDimensionsBlock from '../../streamline-icons/bold/real-estate-dimensions-block.svg';

export default builder(
  'IconRealEstateDimensionsBlockBold',
  RealEstateDimensionsBlock,
);
